import { Inject, Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { UnespCoreEnvironment } from '@unesp/core'
import { identity, Observable } from 'rxjs'
import { ErrorHandlerService } from './error-handler.service'

@Injectable({
  providedIn: 'root',
})
export class CertificadoService {
  private baseUrl: string

  constructor(
    private http: HttpClient,
    private errorHandlerService: ErrorHandlerService,
    @Inject('environment') env: UnespCoreEnvironment
  ) {
    this.baseUrl = env.baseUrlApi
  }

  verificar(codigo: string): Observable<any> {
    let headerOptions = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/pdf',
    })
    let requestOptions = { headers: headerOptions, responseType: 'blob' as 'blob' }
    return this.http
      .get(`${this.baseUrl}/publico/certificado/${codigo}`, requestOptions)
      .pipe(identity, this.errorHandlerService.catchError())
  }
}
